import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { MIN_HEIGHT, MIN_WIDTH } from './constants';
import { MultiImageFileError } from './types';

const FailedImagesListRoot = styled.div`
  display: flex;
  flex-direction: column;
  margin-block-start: 8px;
`;

const ErrorGroup = styled.ul`
  margin: 0;
  padding: 0;
  list-style-position: inside;
`;

const ErrorListItem = styled.li`
  overflow-wrap: anywhere;
`;

const FailedImagesList = ({ errors }: { errors: MultiImageFileError[] }) => {
  const sizeErrors = errors.filter(error => error.type === 'error-image-too-small');
  const unknownErrors = errors.filter(error => error.type === 'error-unknown');

  return (
    <FailedImagesListRoot>
      {sizeErrors.length > 0 && (
        <ErrorGroup style={{ marginBlockEnd: '4px' }}>
          <FormattedMessage
            id="image-upload.errorTooSmall"
            values={{
              width: MIN_WIDTH,
              height: MIN_HEIGHT,
            }}
          />
          {sizeErrors.map((error, index) => (
            <ErrorListItem key={index}>{error.fileName}</ErrorListItem>
          ))}
        </ErrorGroup>
      )}
      {unknownErrors.length > 0 && (
        <ErrorGroup>
          <FormattedMessage id="errors.unknown-error-occurred" />
          {unknownErrors.map((error, index) => (
            <ErrorListItem key={index}>{error.fileName}</ErrorListItem>
          ))}
        </ErrorGroup>
      )}
    </FailedImagesListRoot>
  );
};

export default FailedImagesList;
